import { Link, usePage } from '@inertiajs/react'
import { cn } from '@/lib/utils'
import type { SharedProps } from '@/types'
import Flash from '@/components/ui/Flash'

const USER_NAV = [
  { href: '/dashboard', label: 'Dashboard' },
  { href: '/episodes', label: 'Episodes' },
  { href: '/favorites', label: 'Favorites' },
  { href: '/history', label: 'History' },
  { href: '/billing', label: 'Billing' },
  { href: '/settings', label: 'Settings' },
]

export function UserSidebar({ active }: { active: string }) {
  const { auth } = usePage<SharedProps>().props
  const user = auth.user
  const isPro = user?.subscription_status === 'pro'

  return (
    <>
    <aside className="w-60 shrink-0 bg-white border-r border-gray-100 min-h-screen flex flex-col p-5">
      <Link href="/" className="font-bold text-xl text-gray-900 mb-6 block">GetCasts</Link>

      {/* User info */}
      {user && (
        <div className="flex items-center gap-3 mb-6 px-1">
          {user.avatar_url ? (
            <img src={user.avatar_url} alt={user.name} className="w-8 h-8 rounded-full object-cover shrink-0" />
          ) : (
            <span className="w-8 h-8 rounded-full bg-brand text-white text-xs flex items-center justify-center font-semibold shrink-0">
              {user.name?.[0]?.toUpperCase() ?? '?'}
            </span>
          )}
          <div className="min-w-0">
            <p className="text-sm font-medium text-gray-900 truncate">{user.name}</p>
            <p className="text-xs text-gray-400 capitalize">{user.subscription_status}</p>
          </div>
        </div>
      )}
      <nav className="space-y-1 flex-1">
        {USER_NAV.map(l => (
          <Link
            key={l.href}
            href={l.href}
            className={cn(
              'block px-3 py-2 rounded-lg text-sm transition-colors',
              active === l.href
                ? 'bg-gray-100 text-gray-900 font-medium'
                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
            )}
          >
            {l.label}
          </Link>
        ))}
      </nav>

      {isPro ? (
        <div className="mt-auto bg-brand rounded-xl p-4 text-white">
          <p className="font-bold text-sm">Pro Monthly</p>
          <p className="text-xs opacity-80 mt-0.5">Active subscription</p>
          <Link href="/billing" className="text-xs underline opacity-90 mt-1 block">Manage billing →</Link>
        </div>
      ) : (
        <div className="mt-auto">
          <Link href="/pricing">
            <button className="w-full py-2 text-sm font-medium bg-brand text-white rounded-xl hover:bg-brand-hover transition-colors">
              Upgrade to Pro
            </button>
          </Link>
        </div>
      )}
    </aside>
    <Flash />
  </>
  )
}
